import React, { useState, useEffect } from "react";
import Header from "../header2/Header";
import Seo from "../seo/Seo";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { NavLink } from "react-router-dom";
 
import FilterBar from "../filter-bar";
import JobCard from "../job-card";
 

const Career = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    to: "hr@grank.co.in",
    subject: "Career Enquiry For G-Rank",
    name: "",
    email: "",
    phone: "",
    designation: "",
    city: "",
    message: "",
    cc: "suresh@grank.co.in, singam@grank.co.in",
    bcc: "server@grank.co.in",
  });

 const jobOpenings = [
  {
    id: 1,
    title: "Sr. Sales Executive",
    job_type: "Full Time",
    location: "Bengaluru, Hyderabad",
    note: ["Sales Development", "B2B Sales", "B2C Sales"],
      experience_range: "0 - 4 Yrs",
    summary_description: "This position focuses on acquiring new clients for the organization, while fostering trust and rapport in yourself and the company.",
    description: [
      "This position focuses on acquiring new clients for the organization, while fostering trust and rapport in yourself and the company.",
      "Develop and execute sales strategies to acquire new clients.",
      "Identifying and Pursuing New Business Opportunities: Research potential markets, identify leads, and develop strategies to acquire new clients.",
      "Conducting Market Research and Analysis: analyse market trends, competitor activity, potential customers, schedule meetings, and generate revenue.",
      "Prospect, identify, and qualify potential clients in need of digital marketing services.",
      "Develop and implement strategic business development plans to achieve sales targets and expand market share.",
      "Lead the end-to-end process from initiation to closure of deals, including communication and follow-up with leads via email, phone, virtual, and face-to-face meetings.",
      "Build and maintain strong relationships with key decision-makers and stakeholders within target organizations.",
      "Maintain accurate records of all lead interactions and activities in CRM systems.",
      "Work closely with the client success manager and operational teams to manage sales workflows and operations.",
      "Collaborate with cross-functional teams to set client expectations.",
      "Accountable for ensuring timely payment collections in accordance with company-approved terms.",
      "Generating leads and fixing up appointments with clients to explain the services through online or offline mode.",
      "Implement a systematic follow-up process with clients to convert sales pitches within defined timelines.",
      "Manage key accounts, identifying opportunities to upsell and cross-sell services to increase revenue growth.",
      "Build strong relationships with existing clients through regular communication, ensuring high levels of client satisfaction and retention.",
      "Collaborate with internal teams to develop targeted campaigns that drive business development.",
      "Employees will receive timely guidance and training to accelerate their success in the role.",
      "Responsible for executing field-based sales operations to drive client acquisition.",
    ],
    requirements: [
      "Candidates must possess either a Master in Business Administration/Post Graduate Diploma in Business Administration or an equivalent course.",
      "Candidates with 0-4 years of experience, including freshers, are encouraged to apply.",
      "Candidates must have their own mode of transport.",
      "Strong command of both verbal and written communication.",
      "Proficiency in the Microsoft Office Suite is required.",
    ],
  },
  {
    id: 2,
    title: "Team Lead - Digital Marketing",
    job_type: "Full-time",
    location: "Begumpet, Hyderabad",
    note: ["SEO", "SMO", "PPC", "Team Lead"],
      experience_range: "4 - 7 Years",
    summary_description: "As a Digital Marketing Team Lead, you will take charge of directing and guiding a team of digital marketing professionals.",
    description: [
      "As a Digital Marketing Team Lead, you will take charge of directing and guiding a team of digital marketing professionals. You will be responsible for managing paid campaigns across various digital channels, including search engines and social media, while formulating and executing strategies that drive results. Your role will involve troubleshooting, optimizing, and scaling campaigns to meet business objectives, while ensuring a collaborative and growth-oriented team environment. Client interaction and delivering superior campaign performance will also be key aspects of the role.",
      "Search Engine Marketing (SEM): Lead the development and execution of comprehensive marketing strategies across platforms such as Google Ads, Bing Ads, Taboola Ads, etc., with a focus on driving high-quality leads and boosting web traffic.",
      "Manage the Google MCC account, and provide direction to the team on setting up and managing new ad accounts and campaigns.",
      "Guide the team in YouTube Ads, Programmatic Ads campaign setups, and performance monitoring to ensure results.",
      "Conduct thorough keyword research, write compelling ad copy, and oversee CRM integrations, ensuring landing pages are optimized for maximum conversions.",
      "Continuously track and analyze campaign performance metrics, using data to make informed decisions that improve effectiveness and support business growth.",
      "Collaborate with management to identify opportunities for campaign expansion and scaling.",
      "Social Media Marketing (SMM): Oversee and lead social media campaigns on platforms like Facebook, X (formerly Twitter), Instagram, LinkedIn, and others to build brand visibility and engage target audiences.",
      "Continuously monitor social media metrics, manage CRM integrations, and develop compelling ad copy to generate quality leads and website traffic.",
      "Work closely with clients to understand their objectives and ensure the delivery of campaigns that exceed expectations.",
      "Team Leadership & Client Interaction: Mentor, manage, and develop a team of digital marketing specialists, creating a collaborative and growth-oriented work environment.",
      "Build and maintain strong client relationships, understanding their needs and ensuring consistent delivery of high-quality results.",
      "Foster a team-oriented culture, encouraging cooperation between teams for campaign creatives, landing page optimization, and strategy development.",
      "Analytics, Reporting & Tools: Utilize tools such as Looker Studio, SEMRush, and other data visualization platforms to analyze campaign performance and provide actionable insights.",
      "Generate detailed reports with clear recommendations for optimizing marketing strategies based on performance data.",
      "Stay current with the latest digital marketing trends and emerging technologies.",
      "Leverage advanced tools like Search Ads 360, Display & Video 360 (DV360), and third-party analytics tools for comprehensive campaign analysis.",
      "Ensure correct implementation and reporting through Google Tag Manager (GTM) for accurate tracking and performance measurement.",
    ],
    requirements: [
      "4-7 years of experience in Search Engine Marketing (SEM), Paid Search (PPC), and social media campaign management.",
      "Proficiency with Canva, Google Office Suite, Google Analytics, and Bing Analytics.",
      "Strong skills in using data visualization tools (Looker Studio, SEMRush) and CRM integrations (Zapier, Zoho).",
      "Experience with GTM for tag implementation and campaign tracking.",
      "Excellent leadership, client management, and communication skills.",
      "Prior experience in a digital marketing agency is preferred.",
      "Knowledge of Search Ads 360, DV360, and SEO strategies is highly desirable.",
      "Qualifications: Graduation",
      "Experience: 3 - 6 years",
      "CTC: Competitive and commensurate with experience",
    ],
  },
  {
    id: 3,
    title: "Digital Marketing Specialist",
    job_type: "Full-time",
    location: "Begumpet, Hyderabad",
    note: ["PPC", "SEO", "Analytics"],
      experience_range: "1 - 3 Years",
    summary_description: "As a Digital Marketing Specialist, you would be responsible for handling paid marketing campaigns across various search engine channels & social media platforms.",
    description: [
      "As a Digital Marketing Specialist, you would be responsible for handling paid marketing campaigns across various search engine channels & social media platforms.",
      "She/he should be able to executing marketing strategies, troubleshoot, optimize & scaling up campaigns to increase the online presence and achieve the business objectives.",
      "Search Engine Marketing (SEM): Develop and implement effective marketing strategies across multiple platforms (e.g., Google Ads, Bing Ads & Taboola Ads) to generate high-quality leads and increase website traffic.",
      "Conduct keyword research, create compelling ad copy, CRM integrations and optimize landing pages for better conversion rates.",
      "Continuously monitor campaigns, analyse performance metrics, and make data-driven decisions to enhance campaign performance.",
      "Developing marketings plan to assist management with new upscaling opportunities.",
      "Social Media Marketing (SMM): Manage and execute social media campaigns across various platforms (e.g., Facebook, Twitter, Instagram, LinkedIn) to increase brand visibility, engage with the target audience, drive traffic to our website & generate quality leads.",
      "Continuously monitor campaigns, Analyse social media metrics, CRM Integrations, ad copy writing.",
      "Analytics and Reporting: Analysing marketing campaign performance using various analytics tools.",
      "Generate comprehensive reports with actionable insights and recommendations for optimizing marketing strategies to present to clients.",
      "Keeping track of latest industry trends & practices and emerging technologies in digital marketing.",
      "Coordinating with Internal teams for campaign creatives & landing page optimizations.",
    ],
    requirements: [
      "1-3 years of experience in Search Engine Marketing (SEM) and Paid Search (PPC).",
      "Competent at the Canva, Google Office Suite.",
      "In- depth Knowledge on Google Analytics, Bing Analytics and other web analytics tools.",
      "Having Knowledge on CRM’s integration (Eg: Zapier, Zoho) is preferred.",
      "Working experience on tracking & tag Implementation using GTM tools are preferred.",
      "Qualifications: Graduation",
      "Experience: 1-3 years",
      
    ],
  },
  {
  "id": 4,
  "title": "Associate Trainee - Digital Marketing",
  "job_type": "Full-time",
  "location": "Begumpet, Hyderabad",
  "note": ["PPC", "SEO", "Paid Ads", "Analytics"],
  "experience_range": "0 - 1 Years",
  "summary_description": "As an Associate Trainee - Digital Marketing, you will support the paid marketing team in campaign execution, optimization, and performance tracking across platforms such as Google Ads, Meta Ads, LinkedIn Ads, and Programmatic.",
  "description": [
    "Execute and manage campaigns across Google Ads, Meta Ads, and other digital platforms under the guidance of senior team members.",
    "Implement campaign changes and optimizations based on performance insights, budget pacing, and business goals.",
    "Conduct keyword research and audience research to identify high-performing segments for paid campaigns.",
    "Collaborate with the content and creative teams in planning ad copies, creatives, and A/B tests.",
    "Monitor daily campaign performance and maintain campaign dashboards and reports.",
    "Prepare weekly and monthly reports summarizing CTR, CPC, CPL, and conversion metrics.",
    "Maintain proper documentation of campaigns, reports, and optimization updates.",
    "Research new tools, competitor strategies, and emerging trends in performance marketing.",
    "Gain hands-on experience in campaign setup, analytics, bidding strategies, and scaling performance campaigns."
  ],
  "requirements": [
    "Basic understanding of PPC, SEO, and social media advertising concepts.",
    "Strong analytical skills with proficiency in Excel or Google Sheets.",
    "Attention to detail and eagerness to learn platforms like Google Ads and Meta Ads.",
    "Good communication and reporting skills.",
    "Bachelor’s Degree in Marketing, Business, Communication, or a related field.",
    "Google or Meta certification preferred but not mandatory.",
    "Mandatory completion of a recognized Digital Marketing Certification program."
  ]
}

];

  const [file, setFile] = useState(null); // Separate state for file
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [loading, setLoading] = useState(false); // Track loading state

  const siteKey = "6LcuJ9QmAAAAAGeBZPkD4Am3FwfPo7fJoowZQpvI"; // reCAPTCHA site key
   // New state to manage the selected job posting
  const [selectedJob, setSelectedJob] = useState(null);
   const [filteredJobs, setFilteredJobs] = useState(jobOpenings);

  useEffect(() => {
    // Load reCAPTCHA script
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    document.body.appendChild(script);
  }, [siteKey]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true); // Set loading state to true

    // Execute reCAPTCHA and get token
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action: "submit" })
        .then(async (token) => {
          setRecaptchaToken(token);
          console.log("reCAPTCHA token:", token); // Print token to console

          // Create FormData object for file upload
          const formDataObj = new FormData();
          for (const key in formData) {
            formDataObj.append(key, formData[key]);
          }

          if (file) {
            formDataObj.append("filee", file); // Append file to formDataObj
          }
          formDataObj.append("token", token); // Append reCAPTCHA token

          try {
            const response = await fetch(
              "https://server.grank.co.in/send-email2", // Ensure this is your correct backend URL
              {
                method: "POST",
                body: formDataObj,
              }
            );

            if (response.ok) {
              const result = await response.json();
              console.log(result.message);
              navigate("/thank-you");
            } else {
              const errorResult = await response.json();
              console.error("Error:", errorResult.error);
            }
          } catch (error) {
            console.error("Error:", error);
          } finally {
            setLoading(false); // Reset loading state
          }
        })
        .catch((error) => {
          console.error("reCAPTCHA error:", error);
          setLoading(false); // Reset loading state on error
        });
    });
  };

  // Handle input field changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFile(files[0]); // Set file for upload
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Grank",
    url: "https://www.grank.co.in/career",
    logo: "https://www.grank.co.in/assest/photos/g-rank-white-logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "8522953903",
      contactType: "",
      areaServed: "IN",
      availableLanguage: "en",
    },
    sameAs: [
      "https://www.facebook.com/Grank.India",
      "https://twitter.com/Grank_India/",
      "https://www.instagram.com/grank.india/",
      "https://www.youtube.com/channel/UCAuK0EC-TmLLHVSmrjxMnIA",
      "https://www.linkedin.com/company/g-rank-digital-marketing-company/",
    ],
  };

 
  useEffect(() => {
    if (jobOpenings.length > 0) {
      setSelectedJob(jobOpenings[0]);
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    document.body.appendChild(script);
  }, [siteKey]);

  // New function to pre-fill the form and scroll down
  const handleApplyNow = (jobTitle) => {
    setFormData({
      ...formData,
      designation: jobTitle,
    });

    // Smooth scroll to the form section
    const formSection = document.getElementById("application-form");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [expandedJobId, setExpandedJobId] = useState(null);

 

  const onToggleExpand = (jobId) => {
    setExpandedJobId(expandedJobId === jobId ? null : jobId);
  };

  return (
    <>
      <Seo
        title="Careers | G-Rank"
        description="Explore our Career webpage to discover exciting opportunities, a supportive work environment, and a chance to be part of a dynamic team."
        name="Company name."
        type="article"
        YahooSeeker="INDEX, FOLLOW"
        msnbot="INDEX, FOLLOW"
        googlebot="INDEX, FOLLOW"
        keywords="react, meta tags, seo"
        searchengines="ALL"
        canonical="https://www.grank.co.in/career"
        schema={schema}
      />
      <section className="section-top">
        <Header />
        {/* banner start */}
        <div
          className="creative-banner-display-ads"
          style={{ backgroundColor: "#fff", position: "relative" }}
        >
          <img
            className="img-fluid w-100 career-img-banner "
            src="assest/photos/career/career-banner.png"
            alt="G-Rank"
            title="career"
          />
          <div className="career-banner-div">
            <h2 className="waviy ">
              <span style={{ color: "#fff" }}>Hello there!</span>
            </h2>
            <motion.h3
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.2 }}
            >
              If you have it in you to be a change-maker, team player and
              impactful contributor, you are welcome.
            </motion.h3>
            <Breadcrumbs
              className=" breadcrumbs"
              aria-label="breadcrumb"
              style={{
                paddingTop: "40px",
                display: "flex",
                justifyContent: "center",
                color: "#fff",
              }}
            >
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#000" : "#fff",
                })}
                to="/"
              >
                <p>Home</p>
              </NavLink>
              <Typography color="#fff">Careers</Typography>
            </Breadcrumbs>
          </div>
          <div className="career-yellow-div">
            <h2>What we look for in you</h2>
          </div>
        </div>
        {/* banner end */}

     

        {/* second-section start */}
        <section className="career-second-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-4 col-lg-4 career-second-div">
                <motion.img
                  className="img-fluid"
                  src="assest/photos/career/career-icon1.png"
                  alt="G-Rank"
                  title="career"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                />
                <h3>People Skills</h3>
                <p>
                  We seek individuals with excellent interpersonal skills,
                  capable of building strong relationships within the team.
                </p>
              </div>
              <div className="col-12 col-md-4 col-lg-4 career-second-div">
                <motion.img
                  className="img-fluid"
                  src="assest/photos/career/career-icon2.png"
                  alt="G-Rank"
                  title="career"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                />
                <h3>Growth Mindset</h3>
                <p>
                  We look for individuals who are eager to learn and adapt,
                  contributing to their personal and professional growth.
                </p>
              </div>
              <div className="col-12 col-md-4 col-lg-4 career-second-div">
                <motion.img
                  className="img-fluid"
                  src="assest/photos/career/career-icon3.png"
                  alt="G-Rank"
                  title="career"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                />
                <h3>Team Player</h3>
                <p>
                  We value collaboration and the ability to work effectively
                  with others towards common goals.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* second-section end */}


       {/* Master-Detail Layout for Job Postings */}
      <section className="job-post-section">
        {/* ... (existing job list and details) */}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h2 className="section-title">Current Job Openings</h2>
            </div>
              <FilterBar jobOpenings={jobOpenings} setFilteredJobs={setFilteredJobs} />
      <div className="job-card-list col-12">
        {filteredJobs.map(job => (
          <JobCard
            key={job.id}
            job={job}
            handleApplyNow={handleApplyNow}
            isExpanded={job.id === expandedJobId}
            onToggleExpand={onToggleExpand}
          />
        ))}
      </div>
            

          </div>
        </div>
       

          

 
     



      </section>

        <section className="career-form-section" id="application-form">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className="contact-us-form">
                  <h1 className="apnow">Join Us Now</h1>
                  <form onSubmit={handleSubmit}>
                    <div className="contact-flex">
                      <input
                        className="floating-label"
                        placeholder="Name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="contact-flex">
                      <input
                        placeholder="Email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="contact-flex">
                      <input
                        placeholder="Phone"
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="contact-flex">
                      <input
                        placeholder="Designation"
                        type="text"
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="contact-flex">
                      <select
                        name="city"
                        className="contact-select-div"
                        value={formData.city}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Preferred Location
                        </option>
                        <option value="Hyderabad">Hyderabad</option>
                        <option value="Bangalore">Bangalore</option>
                        <option value="Any Location">Any Location</option>
                      </select>
                    </div>

                    <div className="contact-flex">
                      <textarea
                        placeholder="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="contact-flex">
                      <input
                        type="file"
                        className="sdupload"
                        placeholder="Upload File"
                        name="filee"
                        onChange={handleChange}
                      />
                    </div>
                    <h4>
                      <button type="submit" disabled={loading}>
                        {loading ? "Applying..." : "Apply Now"}
                      </button>
                    </h4>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Career;
